import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  HostListener,
  Input,
} from '@angular/core';
import { CommonModule } from '@angular/common';

export interface VerticalStepperData {
  headerText: string;
  subHeaderText: string;
}

@Component({
  selector: 'app-vertical-stepper',
  templateUrl: './vertical-stepper.component.html',
  styleUrl: './vertical-stepper.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule],
})
export class VerticalStepperComponent implements AfterViewInit {
  @Input() steps: VerticalStepperData[] = [];
  @Input() activeStepIndex: number = 0;

  lineHeight: number = 0;

  constructor(private el: ElementRef, private cdr: ChangeDetectorRef) {}

  @HostListener('window:resize', ['$event'])
  onResize() {
    this.setLineHeight();
  }

  ngAfterViewInit(): void {
    this.setLineHeight();
  }

  getActiveLineHeight(stepIndex: number, fullHeight: boolean = false): string {
    const elementHeight: number = (
      document.querySelectorAll('div.step-wrapper')[stepIndex] as HTMLElement
    ).offsetHeight;
    if (fullHeight) {
      return (elementHeight + 34).toString() + 'px';
    }
    return (elementHeight - 34 / 2).toString() + 'px';
  }

  private setLineHeight(): void {
    const lastStepHeight =
      this.el?.nativeElement?.lastElementChild?.lastElementChild?.offsetHeight;
    this.lineHeight =
      this.el?.nativeElement?.children[0]?.offsetHeight -
      (lastStepHeight ? lastStepHeight : 20);
    this.cdr.detectChanges();
  }
}
